module.exports = __webpack_public_path__ + "static/media/isotype_white.88583880.svg";